import React from 'react'

import { TtIcon } from '@23/react'

import './FocusPreviewTrayScreenshare.scss'

const FocusPreviewTrayScreenshare = () => {
  return (
    <div className="focus-preview-tray-screenshare">
      <div className="focus-preview-tray-screenshare-frame">
        <TtIcon library="one/webinars" name="screen-share" />
      </div>
    </div>
  )
}

export { FocusPreviewTrayScreenshare }
